import {
  GET_CASHBOOK_HEAD_LIST,
  GET_CASHBOOK_HEAD_LIST_SUCCESS,
  SAVE_CASHBOOK_HEAD,
  SAVE_CASHBOOK_HEAD_SUCCESS,
  EDIT_CASHBOOK_HEAD_ID,
  EDIT_CASHBOOK_HEAD_ID_SUCCESS,
  UPDATE_CASHBOOK_HEAD_ID,
  UPDATE_CASHBOOK_HEAD_ID_SUCCESS,
  DELETE_CASHBOOK_HEAD_ID,
  DELETE_CASHBOOK_HEAD_ID_SUCCESS,
  CASHBOOK_HEAD_API_ERROR_ACTION,
} from "./actionTypes";

const INIT_STATE = {
  postMsg: { Status: false },
  CashBookHeadListData: [],
  deleteMessage: { Status: false },
  editData: { Status: false },
  updateMessage: { Status: false },
  saveBtnloading: false,
  listBtnLoading: false,
  goBtnLoading: false,
}

const CashBookHeadReducer = (state = INIT_STATE, action) => {
  switch (action.type) {

    // list
    case GET_CASHBOOK_HEAD_LIST:
      return { ...state, goBtnLoading: true }

    case GET_CASHBOOK_HEAD_LIST_SUCCESS:
      return { ...state, CashBookHeadListData: action.payload, goBtnLoading: false }

    // save
    case SAVE_CASHBOOK_HEAD:
      return { ...state, saveBtnloading: true }

    case SAVE_CASHBOOK_HEAD_SUCCESS:
      return { ...state, postMsg: action.payload, saveBtnloading: false }

    // edit
    case EDIT_CASHBOOK_HEAD_ID:
      return { ...state, listBtnLoading: action.config.btnId }

    case EDIT_CASHBOOK_HEAD_ID_SUCCESS:
      return { ...state, listBtnLoading: false, editData: action.payload }

    // update
    case UPDATE_CASHBOOK_HEAD_ID:
      return { ...state, saveBtnloading: true }

    case UPDATE_CASHBOOK_HEAD_ID_SUCCESS:
      return { ...state, updateMessage: action.payload, saveBtnloading: false }

    // delete
    case DELETE_CASHBOOK_HEAD_ID:
      return { ...state, listBtnLoading: action.config.btnId }

    case DELETE_CASHBOOK_HEAD_ID_SUCCESS:
      return { ...state, listBtnLoading: false, deleteMessage: action.payload }

    case CASHBOOK_HEAD_API_ERROR_ACTION:
      return {
        ...state,
        saveBtnloading: false,
        listBtnLoading: false,
        goBtnLoading: false,
      }

    default:
      return state
  }
}

export default CashBookHeadReducer